import React from 'react';
import PropTypes from 'prop-types';
import { FieldLabel } from 'smartsuite-ui/lib/typography/FieldLabel';
import { VerticalFlex } from 'smartsuite-ui/lib/containers/VerticalFlex';

// eslint-disable-next-line complexity
export default function WidgetInfo(props) {
    const { widget } = props;

    if (!widget.panelTitle && !widget.tabTitle) {
        return (
            <span className="widget-library__widget-title">
                {props.widget.stateData.title}
            </span>
        );
    }

    if (widget.panelTitle && widget.tabTitle) {
        return (
            <VerticalFlex>
                <span className="widget-library__widget-title">
                    {props.widget.stateData.title}
                </span>
                <FieldLabel>{`${widget.panelTitle}: ${widget.tabTitle}`}</FieldLabel>
            </VerticalFlex>
        );
    }

    return (
        <VerticalFlex>
            <span className="widget-library__widget-title">
                {props.widget.stateData.title}
            </span>
            <FieldLabel>{`${widget.panelTitle ?? widget.tabTitle}`}</FieldLabel>
        </VerticalFlex>
    );
}

WidgetInfo.propTypes = {
    widget: PropTypes.instanceOf(Object).isRequired,
};
